import { render, staticRenderFns } from "./Ethicalmanagement.vue?vue&type=template&id=9ee911fe&scoped=true&"
import script from "./Ethicalmanagement.vue?vue&type=script&lang=js&"
export * from "./Ethicalmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Ethicalmanagement.vue?vue&type=style&index=0&id=9ee911fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee911fe",
  null
  
)

/* custom blocks */
import block0 from "./Ethicalmanagement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports